import {
  Sofa,
  BedDouble,
  Armchair,
  LayoutGrid,
  Car,
  RectangleHorizontal,
  Home,
  Timer,
  BadgeEuro,
  ShieldCheck,
} from "lucide-react";

export const WHATSAPP_NUMBER = "351920037468";
export const WHATSAPP_DISPLAY = "+351 920 037 468";
export const EMAIL = "contato@topestofos.pt";
export const ADDRESS = "Rua José Campas n.º 2, 1800-236 Lisboa, Portugal";
export const HOURS = "Segunda a sábado — 08:00 às 18:00";
export const INSTAGRAM_URL = "https://www.instagram.com/topestofos";

export const wa = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  default: "Olá! Vi o site da TopEstofos e gostaria de solicitar um orçamento.",
  precos:
    "Olá! Vi os preços no site da TopEstofos e gostaria de pedir um orçamento gratuito.",
  contacto: "Olá! Gostaria de falar com a equipa da TopEstofos.",
};

export const track = (event, data = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
};

const img = (id, w = 900) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  hero: img("photo-1686178827149-6d55c72d81df", 1400),
  about: "/images/sobre.jpg",
  lisbon: img("photo-1605641532626-5ab1dab56350", 1600),
};

export const SERVICES = [
  {
    id: "sofas",
    icon: Sofa,
    name: "Higienização de Sofás",
    short: "higienização de sofá",
    desc: "Remoção profunda de sujidade, manchas e odores, devolvendo frescura ao seu sofá.",
    image: "/images/servico-sofas.jpg",
    alt: "Técnico a higienizar um sofá de tecido com máquina extratora profissional",
  },
  {
    id: "colchoes",
    icon: BedDouble,
    name: "Higienização de Colchões",
    short: "higienização de colchão",
    desc: "Limpeza profunda que ajuda a reduzir ácaros e alergénios, para noites mais tranquilas.",
    image: "/images/servico-colchoes.jpg",
    alt: "Técnico a higienizar um colchão com equipamento de extração profissional",
  },
  {
    id: "poltronas",
    icon: Armchair,
    name: "Higienização de Poltronas",
    short: "higienização de poltrona",
    desc: "Cuidado especializado para poltronas de tecido, com produtos adequados a cada material.",
    image: "/images/higienizacao-poltronas.jpg",
    alt: "Profissional a higienizar uma poltrona de tecido com máquina extratora",
  },
  {
    id: "cadeiras",
    icon: Armchair,
    name: "Higienização de Cadeiras",
    short: "higienização de cadeiras",
    desc: "Limpeza de cadeiras de sala, escritório ou refeitório, em casa ou na sua empresa.",
    image: "/images/servico-cadeiras.jpg",
    alt: "Técnico a higienizar cadeiras estofadas de sala de jantar",
  },
  {
    id: "carpetes",
    icon: LayoutGrid,
    name: "Higienização de Carpetes",
    short: "higienização de carpetes",
    desc: "Lavagem e higienização de carpetes e tapetes com extração profunda de sujidade.",
    image: "/images/servico-carpetes.jpg",
    alt: "Profissional a higienizar uma carpete instalada com máquina de extração",
  },
  {
    id: "cabeceiras",
    icon: RectangleHorizontal,
    name: "Higienização de Cabeceiras",
    short: "higienização de cabeceira",
    desc: "Renove a cabeceira da sua cama com uma limpeza cuidada, eficaz e segura.",
    image: "/images/servico-cabeceiras.jpg",
    alt: "Técnico a higienizar uma cabeceira de cama estofada em tecido",
  },
  {
    id: "automoveis",
    icon: Car,
    name: "Limpeza de Estofos Automóveis",
    short: "limpeza de estofos automóveis",
    desc: "Higienização de bancos e estofos do seu carro, sem sair de casa.",
    image: "/images/limpeza-estofos-auto.jpg",
    alt: "Profissional a higienizar o banco estofado de um automóvel com máquina extratora",
  },
];

export const PRICING = [
  {
    id: "sofas",
    icon: Sofa,
    title: "Sofás",
    items: [
      ["Sofá 2 lugares", "60 €"],
      ["Sofá 3 lugares", "65 €"],
      ["Sofá 4 lugares", "70 €"],
      ["Chaise longue", "+5 €"],
    ],
  },
  {
    id: "colchoes",
    icon: BedDouble,
    title: "Colchões",
    items: [
      ["Colchão de casal", "60 €"],
      ["Colchão de solteiro", "55 €"],
    ],
  },
  {
    id: "cadeiras",
    icon: Armchair,
    title: "Cadeiras e Poltronas",
    items: [
      ["Cadeira com costas", "15 €"],
      ["Cadeira sem costas", "12 €"],
      ["Poltrona", "40 €"],
    ],
  },
  {
    id: "cabeceiras",
    icon: RectangleHorizontal,
    title: "Cabeceiras",
    items: [["Cabeceira", "35 €"]],
  },
  {
    id: "carpetes",
    icon: LayoutGrid,
    title: "Carpetes",
    items: [
      ["Até 5,99 m²", "10,50 €/m²"],
      ["A partir de 6 m²", "10 €/m²"],
      ["A partir de 11 m²", "9 €/m²"],
    ],
  },
  {
    id: "auto",
    icon: Car,
    title: "Estofos Automóveis",
    items: [["Por banco", "12 €"]],
  },
];

export const DIFFERENTIALS = [
  {
    icon: Home,
    title: "Atendimento ao domicílio",
    desc: "Realizamos o serviço no conforto da sua casa.",
  },
  {
    icon: Timer,
    title: "Secagem rápida",
    desc: "Tempo médio de secagem entre 10 e 12 horas.",
  },
  {
    icon: BadgeEuro,
    title: "Orçamento gratuito",
    desc: "Peça o seu orçamento sem compromisso.",
  },
  {
    icon: ShieldCheck,
    title: "Garantia do serviço",
    desc: "Trabalhamos para garantir a qualidade e a sua satisfação.",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Peça o seu orçamento",
    desc: "Entre em contacto através do WhatsApp.",
  },
  {
    n: "02",
    title: "Agende o serviço",
    desc: "Escolha o melhor dia e horário.",
  },
  {
    n: "03",
    title: "Tratamos dos seus estofos",
    desc: "A nossa equipa realiza a higienização profissional.",
  },
  {
    n: "04",
    title: "Desfrute do resultado",
    desc: "Estofos limpos, higienizados e renovados.",
  },
];

export const GALLERY = [
  {
    src: "/images/servico-sofas.jpg",
    alt: "Profissional a realizar higienização de sofá com máquina extratora",
    label: "Higienização de sofá",
  },
  {
    src: "/images/servico-colchoes.jpg",
    alt: "Higienização profissional de colchão",
    label: "Colchões",
  },
  {
    src: "/images/higienizacao-poltronas.jpg",
    alt: "Limpeza profissional de poltrona em tecido",
    label: "Poltronas",
  },
  {
    src: "/images/servico-carpetes.jpg",
    alt: "Limpeza de carpete com equipamento profissional",
    label: "Carpetes",
  },
  {
    src: "/images/limpeza-estofos-auto.jpg",
    alt: "Limpeza de estofos automóveis com máquina extratora",
    label: "Estofos automóveis",
  },
  {
    src: "/images/equipamento.jpg",
    alt: "Equipamento profissional para limpeza e higienização de estofos",
    label: "Equipamento profissional",
  },
];

export const NAV_LINKS = [
  { label: "Serviços", href: "#servicos" },
  { label: "Preços", href: "#precos" },
  { label: "Vantagens", href: "#vantagens" },
  { label: "Como funciona", href: "#como-funciona" },
  { label: "Contactos", href: "#contactos" },
];
